import {
  fetchFileFromRemote,
  getDuration,
  getReminderTimeArray,
  getRemindTimeFromEventData,
  calculateDate,
  getFrequencyOptions,
  defaultFrequencyOption,
} from '../../common/helpers'

export const mapFormDataToAppointmentDto = async (
  formValues,
  selectedBuildingId,
  selectedBuildingTimezone,
) => {
  const image = formValues.image.url
    ? await fetchFileFromRemote(formValues.image.url)
    : formValues.image

  const formData = {
    event: false,
    buildingId: selectedBuildingId,
    // Appointment details
    type: formValues.type.text,
    name: formValues.name,
    trainerId: formValues.organizer.id,
    mainClient: formValues.mainClient.value,
    description: formValues.description,
    image: image,
    files: formValues.files,

    // Date/Time
    place: formValues.place,
    date: calculateDate(formValues.timeStart, selectedBuildingTimezone),
    duration: getDuration(formValues.timeStart, formValues.timeEnd),
    schedulerType:
      formValues.frequency && formValues.frequency !== 'none' ? formValues.frequency : null,

    // Advanced  - communication
    remindRsvpBeforeHours: formValues.remindRsvp
      ? getReminderTimeArray(formValues.remindRsvpValues)
      : [],
    remindAllBeforeHours: formValues.remindAll
      ? getReminderTimeArray(formValues.remindAllValues)
      : [],

    createEventSurvey: formValues.askForPostEventReview,
    socialLinkService: formValues.socialLinkService || null,
    ...(formValues.positiveReview && formValues.replyTo ? { replyTo: formValues.replyTo } : {}),

    // TODO - to delete once ticket step is done
    cost: 0,
  }

  return formData
}

export const mapAppointmentDtoToFormData = ({ eventData, eventTypeOptions, trainerOptions }) => {
  const formData = {
    type: eventTypeOptions.find((option) => option.id === eventData.type.id),
    name: eventData.name,
    organizer: trainerOptions.find((option) => option.id === eventData.trainerId?.id),
    mainClient: { value: eventData.mainClient.id, label: eventData.mainClient.fullName },
    description: eventData.description,
    image: eventData.image,
    files: eventData.files || [],
    // Date/Time
    place: eventData.place,
    timeStart: eventData.start,
    timeEnd: eventData.end,
    frequency:
      getFrequencyOptions().find((option) => option.value === eventData.schedulerType)?.value ||
      defaultFrequencyOption,
    // Advanced - Communication
    automatedRemindersToggle:
      !!eventData.remindAllBeforeHours.length || !!eventData.remindRsvpBeforeHours.length,
    remindRsvp: !!eventData.remindRsvpBeforeHours.length,
    remindRsvpValues: eventData.remindRsvpBeforeHours
      ? getRemindTimeFromEventData(eventData.remindRsvpBeforeHours)
      : [''],
    remindAll: !!eventData.remindAllBeforeHours.length,
    remindAllValues: eventData.remindAllBeforeHours
      ? getRemindTimeFromEventData(eventData.remindAllBeforeHours)
      : [''],
    askForPostEventReview: !!eventData.createEventSurvey,
    positiveReview: !!eventData.socialLinkService,
    socialLinkService: eventData.socialLinkService || '',
    replyTo: eventData.replyTo || '',
  }

  return formData
}
